<div class="gridItemChildModule" style="width: 100%; height: 100%" #heatmapContainer> 
</div>


